import type { ModalHeaderProps as ChakraModalHeaderProps } from '@chakra-ui/react';
import { ModalHeader as ChakraModalHeader } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type ModalHeaderProps = OmitChakraProps<ChakraModalHeaderProps>;

export const ModalHeader = withChakraAs<ModalHeaderProps, 'header'>((props) => {
  return <ChakraModalHeader {...props} />;
});
